import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestionMaterialesComponent } from './materiales/gestion-materiales/gestion-materiales.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DetalleMaterialesComponent } from './materiales/detalle-materiales/detalle-materiales.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { NgxMaskModule } from 'ngx-mask';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion'
import { HomePrincipalComponent } from './home-principal/home-principal.component';
import { NuevoUsuarioComponent } from './admin-usuario/nuevo-usuario/nuevo-usuario.component';
import { DetalleProveedoresComponent } from './detalle-proveedores/detalle-proveedores.component';
import { AsignarPerfilComponent } from './admin-usuario/asignar-perfil/asignar-perfil.component';
import { CargaActualizacionBdComponent } from './admin-configuracion/carga-actualizacion-bd/carga-actualizacion-bd.component';
import { ReseteoMacComponent } from './admin-configuracion/reseteo-mac/reseteo-mac.component';
import { GestionMatCompuestosComponent } from './materiales/gestion-mat-compuestos/gestion-mat-compuestos.component';
import { GestionEquiposComponent } from './equipos/gestion-equipos/gestion-equipos.component';
import { GestionEquiposCompuestosComponent } from './equipos/gestion-equipos-compuestos/gestion-equipos-compuestos.component';
import { DetalleEquiposComponent } from './equipos/detalle-equipos/detalle-equipos.component';
import { GestionManoDeObraComponent } from './mano-de-obra/gestion-mano-de-obra/gestion-mano-de-obra.component';
import { GestionManoObraCompuestaComponent } from './mano-de-obra/gestion-mano-obra-compuesta/gestion-mano-obra-compuesta.component';
import { DetalleManoDeObraComponent } from './mano-de-obra/detalle-mano-de-obra/detalle-mano-de-obra.component';
import { DetalleManoObraCompuestaComponent } from './mano-de-obra/detalle-mano-obra-compuesta/detalle-mano-obra-compuesta.component';
import { PartidasComponent } from './partidas/gestion-partidas/partidas.component';
import { DetallePartidaComponent } from './partidas/detalle-partida/detalle-partida.component';
import { PerfilUsuarioComponent } from './perfil-usuario/perfil-usuario.component';
import { CambioClaveComponent } from './cambio-clave/cambio-clave.component';
import { CambiarFechaBdComponent } from './admin-configuracion/cambiar-fecha-bd/cambiar-fecha-bd.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListaUsuariosComponent } from './admin-usuario/lista-usuarios/lista-usuarios.component';
import { DetalleUsuarioComponent } from './admin-usuario/detalle-usuario/detalle-usuario.component';
import { ModalBienvenidaComponent } from './modal-bienvenida/modal-bienvenida.component';
import { PresupuestosComponent } from './presupuestos/gestion-presupuestos/presupuestos.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatMenuModule } from '@angular/material/menu';
import { DetallePresupuestoComponent } from './presupuestos/detalle-presupuesto/detalle-presupuesto.component';
import { NuevoPresupuestoComponent } from './presupuestos/nuevo-presupuesto/nuevo-presupuesto.component';
import { AgregarEmpresaComponent } from './presupuestos/agregar-empresa/agregar-empresa.component';
import { MaterialesPresupuestoComponent } from './presupuestos/materiales-presupuesto/materiales-presupuesto.component';
import { EquiposPresupuestoComponent } from './presupuestos/equipos-presupuesto/equipos-presupuesto.component';
import { ManoDeObraPresupuestoComponent } from './presupuestos/mano-de-obra-presupuesto/mano-de-obra-presupuesto.component';
import { DatosGeneralesPresupuestoComponent } from './presupuestos/datos-generales-presupuesto/datos-generales-presupuesto.component';
import { CargaActualizacionCapitulosComponent } from './presupuestos/admin-configuracion/carga-actualizacion-capitulos/carga-actualizacion-capitulos.component';
import { CondicionesApuComponent } from './presupuestos/condiciones-apu/condiciones-apu.component';
import { CapitulosPresupuestoComponent } from './presupuestos/capitulos-presupuesto/capitulos-presupuesto.component';
import { CapturarPartidasPresupuestoComponent } from './presupuestos/capturar-partidas-presupuesto/capturar-partidas-presupuesto.component';
import { VerApuPresupuestoComponent } from './presupuestos/ver-apu-presupuesto/ver-apu-presupuesto.component';
import { ModificarPartidaPresupuestoComponent } from './presupuestos/modificar-partida-presupuesto/modificar-partida-presupuesto.component';
import { CambiarFechaBdPresupuestoComponent } from './presupuestos/admin-configuracion/cambiar-fecha-bd-presupuesto/cambiar-fecha-bd-presupuesto.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatDialogModule,
    MatCardModule,
    MatGridListModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    FlexLayoutModule,
    NgxMaskModule.forRoot(),
    MatToolbarModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatListModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatTooltipModule,
    MatBottomSheetModule,
    MatMenuModule
  ],
  declarations: [
    GestionMaterialesComponent,
    DetalleMaterialesComponent,
    HomePrincipalComponent,
    NuevoUsuarioComponent,
    DetalleProveedoresComponent,
    AsignarPerfilComponent,
    CargaActualizacionBdComponent,
    ReseteoMacComponent,
    GestionMatCompuestosComponent,
    GestionEquiposComponent,
    GestionEquiposCompuestosComponent,
    DetalleEquiposComponent,
    GestionManoDeObraComponent,
    GestionManoObraCompuestaComponent,
    DetalleManoDeObraComponent,
    DetalleManoObraCompuestaComponent,
    PartidasComponent,
    DetallePartidaComponent,
    PerfilUsuarioComponent,
    CambioClaveComponent,
    CambiarFechaBdComponent,
    ListaUsuariosComponent,
    DetalleUsuarioComponent,
    ModalBienvenidaComponent,
    NuevoPresupuestoComponent,
    PresupuestosComponent,
    DetallePresupuestoComponent,
    AgregarEmpresaComponent,
    MaterialesPresupuestoComponent,
    EquiposPresupuestoComponent,
    ManoDeObraPresupuestoComponent,
    DatosGeneralesPresupuestoComponent,
    CargaActualizacionCapitulosComponent,
    CondicionesApuComponent,
    CapitulosPresupuestoComponent,
    CapturarPartidasPresupuestoComponent,
    VerApuPresupuestoComponent,
    ModificarPartidaPresupuestoComponent,
    CambiarFechaBdPresupuestoComponent
  ]
})
export class ComponentsModule { }
